export type EditableImageUi = {
  savedImage?: string;
  showDialog?: boolean;
  dialogImage?: string;
  cancelDisabled?: boolean;
  saveDisabled?: boolean;
  imageEditable?: boolean;
  isSaving?: boolean;
};

export const initialState: EditableImageUi = { saveDisabled: true };
